<template>
  <!-- router main -->
    <router-view />
</template>

//
<div id="nav">
//   <router-link to="/">Home</router-link> |
//   <router-link to="/Login">Login</router-link> |
//   <router-link to="/Rfid">Rfid</router-link> |
//     <router-link to="/Menu">Menu</router-link> |
//     <router-link to="/Temp">Blank</router-link> |
//     <router-link to="/Table">Table</router-link> |
// </div>

<script>
export default {
    data() {
        return {
            isTitleIf: this.$store.state.isTitleVIf,
            isMenuVIf: true,
        };
    },

    created() {
        // this.isMenuVIf=false;
        //this.isTitleIf=this.$store.state.isTitleVIf;
    },

    methods: {
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
    },
};
</script>

<style>
/* ===== Pretendard (local TTF) — weight별 등록 ===== */
@font-face {
    font-family: "Pretendard";
    src: url("./views/resource/fonts/Pretendard-Regular.ttf") format("truetype");
    font-weight: 400; /* Regular */
    font-style: normal;
    font-display: swap;
}
@font-face {
    font-family: "Pretendard";
    src: url("./views/resource/fonts/Pretendard-Medium.ttf") format("truetype");
    font-weight: 500; /* Medium */
    font-style: normal;
    font-display: swap;
}
@font-face {
    font-family: "Pretendard";
    src: url("./views/resource/fonts/Pretendard-Bold.ttf") format("truetype");
    font-weight: 700; /* Bold */
    font-style: normal;
    font-display: swap;
}
@font-face {
    font-family: "Pretendard";
    src: url("./views/resource/fonts/Pretendard-ExtraBold.ttf") format("truetype");
    font-weight: 800; /* ExtraBold */
    font-style: normal;
    font-display: swap;
}

/* ===== Global Font Stack ===== */
:root {
    --font-sans: "Pretendard", "Noto Sans KR", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, Arial, "Apple SD Gothic Neo", "Malgun Gothic",
    "Helvetica Neue", system-ui, sans-serif;
    /* Element Plus/Element UI 전역 폰트 */
    --el-font-family: var(--font-sans);
}

/* ===== Global Apply ===== */
html,
body,
#app {
    height: 100%;
}
html {
    font-size: 15px;
}
body {
    background: #eef1f4 !important;
    font-family: var(--font-sans) !important;
    font-weight: 400;
    font-size: 13px;
}

/* ===== Element UI/Plus 주요 컴포넌트 폰트 적용 ===== */
.el-table,
.el-menu,
.el-submenu__title,
.el-menu-item,
.el-button,
.el-input__inner,
.el-select-dropdown__item,
.el-message-box__title,
.el-dialog__title,
.el-pagination,
.el-breadcrumb,
.el-form-item__label,
.el-alert__title {
    font-family: var(--font-sans) !important;
}

/* ===== 기존 스타일 유지 ===== */
.el-main {
    padding: 0.75rem !important;
    overflow: initial !important; /* 또는 unset */
    overflow-x: auto;
    overflow-y: hidden;

}
.bg-purple-light {
    width: 1150px !important;
}
.el-row {
    margin-bottom: 1rem !important;
}
.el-date-table th {
    text-align: center !important;
}

.el-aside {
    color: #013263;
}
.el-submenu__title {
    font-size: 14px !important;
}
.el-menu-item,
.el-submenu__title {
    height: 38px !important;
    display: flex !important;
    align-items: center !important;
}
.el-menu-item {
    font-size: 14px !important;
}

.el-submenu__icon-arrow {
    right: 30px !important;
}
.el-submenu .el-menu-item {
    min-width: 162px !important;
}

.el-table .cell {
    font-size: 9px !important;
    letter-spacing: 1px !important;
}

.el-icon-close:before {
    content: "\e6db";
    font-size: 32px !important;
}
/* 닫기 아이콘에만 적용 */
.el-icon-close::after,
.el-icon-close::before {
    font-size: 32px !important;
}

.searchBody_production {
    width: 50px !important;
    margin-left: 20px !important;
    font-size: 15px !important;
}
.searchBody {
    font-size: 18px !important;
}
</style>
